export default "__VITE_ASSET__CPO92zca__"